import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { HeaderComponentes } from './header.component';
import { MatMenuModule } from '@angular/material/menu';
import { allIcons } from 'angular-feather/icons';
import { FeatherModule } from 'angular-feather';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatMenuModule,
    MatSelectModule,
    FeatherModule.pick(allIcons)
  ],
  declarations: [
    HeaderComponentes
  ],
  exports: [
    HeaderComponentes,
    FeatherModule
  ]
})
export class HeaderModule { }
